import React, { useEffect, useState, useRef } from "react";
import { Text,  View,  TouchableOpacity, Linking} from "react-native";
import { getEncryptKey, getPaymentData, } from "../../api/apiManager";
import AsyncStorageFunc from '../../utilities/asyncStorage';
import { Encryption as encrypt, decrypt, decrypt_mobile } from "../../utilities/Encryption";
import ModalAlert from "../../common/ModalAlert";
import { CreateResponsiveStyle, DEVICE_SIZES, useDeviceSize } from 'rn-responsive-styles';
import Loader from "../../common/Loader";

export default function PaymentScreen(props) {
  const styles = useStyles()
  const [HTMLDATA, setHTMLDATA] = useState("");
  const [orderId, setOrderId] = useState("");
  const [toHome, setToHome] = useState(false);
  const [apiData, setApiData] = useState("");
  const [loading, setLoading] = useState(false);
  const [apiPageLoader, setApiPageLoader] = useState(false);
  const [alertModalVisible, setAlertModalVisible] = useState(false);
  const [paymentDone, setPaymentDone] = useState(false);
  const [alertModal, setAlertModal] = useState({
    title: "",
    status: "",
    message: "",
    navigateScreen: "",
    actionButton: ""
  });
  const onCloseModal = () => {
    setAlertModalVisible(false);
  };

  useEffect(() => {
    let isCancelled = false;
    const initializePayment = async () => {
      let reqObj = {
        deviceId: "KA03MP1234"
      };
      setLoading(true)
      getEncryptKey(reqObj)
        .then(encRes => {
          encrypt(props.paymentData?.card_breakup?.totalAmt + "", encRes.data).then(
            encAmount => {
              let req = {}
              if (props.screen == "Recharge") {
                req = props.paymentData
              }
              else {
                req = {
                  useCase: "tagIssue",
                  tagId: "",
                  mobileNo: null,
                  vehicleClass: props.paymentData?.card_breakup?.cardNumber,
                  amount: encAmount,
                };
              }
              getPaymentData(req)
                .then(res => {
                  if (res.statusCode < 0 || res.statusCode == 500 || res.statusCode == 400 || res.statusCode == -1017) {
                    setAlertModal({
                      title: "Error",
                      status: "error",
                      message: res.message,
                      navigateScreen: "",
                      actionButton: "OK"
                    });
                    setAlertModalVisible(true);
                    setLoading(false)
                  } else {

                    setHTMLDATA(res.response.paymentEncKey);
                    setOrderId(res.response.orderId);
                    AsyncStorageFunc.storeData('ORDERID', res.response.orderId)
                    setLoading(false)
                  }
                })
                .catch(err => {
                  setAlertModal({
                    title: "Error",
                    status: "error",
                    message: err.message,
                    navigateScreen: "",
                    actionButton: "OK"
                  });
                  setAlertModalVisible(true);
                  setLoading(false)
                });

            }
          );
        })
        .catch(err => {
          setAlertModal({
            title: "Error",
            status: "error",
            message: err.message,
            navigateScreen: "",
            actionButton: "OK"
          });
          setAlertModalVisible(true);
        });
    }
    initializePayment()
  }, [props.paymentData?.card_breakup?.totalAmt])
  const ref = useRef();

  useEffect(() => {
  }, [ref?.current?.src])


  return (
    <View style={styles.container}>
      <View style={styles.stepWidget}>
        {HTMLDATA != "" &&
          <TouchableOpacity onPress={() => Linking.openURL(`https://test.ccavenue.com/transaction.do?command=initiateTransaction&encRequest=${HTMLDATA}&access_code=AVPE03IF79AF13EPFA`)}>
            <Text> Payment Now</Text>
          </TouchableOpacity>
        }
      </View>


      {alertModalVisible && (
        <View style={styles.overlayViewStyle}>
          <ModalAlert
            title={alertModal.title}
            status={alertModal.status}
            message={alertModal.message}
            navigateScreen={alertModal.navigateScreen}
            actionButton={"OK"}
            onCloseModal={onCloseModal}
          />

        </View>
      )}
      {loading && <Loader />}
    </View>
  );
}

const useStyles = CreateResponsiveStyle(
  {
    container: {
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      marginTop: 10
    },
    backBtnWidget: {
      flexDirection: 'row',
      alignItems: 'center'
    },
    stepWidget: {
      backgroundColor: '#fff',
      borderRadius: 10,
      padding: 10,
      marginTop: 10,
      width: '100%',
      marginLeft: 20,
      minHeight: 300
    },
    overlayViewStyle: {
      position: "absolute",
      zIndex: 9999,
      backgroundColor: "rgba(52,52,52,0.9)",
      width: "100%",
      height: "100%",
      top: 0,
      left: 0,
      borderRadius: 15,
    },
    overlayContainer: {
      width: "100%",
      height: "100%",
      zIndex: 99999,
    },
    overlay: {
      width: "100%",
      height: "100%",
      justifyContent: "center",
      alignItems: "center",
    },
    loaderBg: {
      backgroundColor: "white",
      width: "50%",
      borderRadius: 20,
      justifyContent: "flex-start",
      alignItems: "center",
      shadowColor: "rgba(0,0,0,0.05)",
      shadowOpacity: 1.5,
      elevation: 12,
      shadowRadius: 20,
      shadowOffset: { width: 1, height: 13 },
    },
    overlayContentViewStyle: {
      width: 348.1,
      height: 269.7,
      borderRadius: 13,
      backgroundColor: "#ffffff",
      shadowColor: "rgba(0, 0, 0, 0.05)",
      shadowOffset: {
        width: 0,
        height: 27,
      },
      shadowRadius: 34,
      shadowOpacity: 1,
    },
  },

  {
    [DEVICE_SIZES.XL]: {
      container: {
      },
    },
    [DEVICE_SIZES.LG]: {

    },
    [DEVICE_SIZES.SM]: {
      container: {
        flexDirection: 'column',
      },


    },
    [DEVICE_SIZES.XS]: {

    },
    [DEVICE_SIZES.MD]: {
      container: {
        flexDirection: 'column',
      },
    },
  },
)